import { APIClient } from "../helpers/api_helper";
import { ApiResponse } from "../types/api";

const api = new APIClient();

export interface UnitScheduleSlot {
  id?: number;
  unit_id?: number;
  day_of_week: number;
  start_time: string;
  end_time: string;
}

export interface SyncUnitSchedulePayload {
  schedules: Array<{
    day_of_week: number;
    start_time: string;
    end_time: string;
  }>;
}

export const getUnitSchedules = (
  unitId: number
): Promise<ApiResponse<UnitScheduleSlot[]>> =>
  api.get<ApiResponse<UnitScheduleSlot[]>>(`/units/${unitId}/schedules`);

export const syncUnitSchedules = (
  unitId: number,
  payload: SyncUnitSchedulePayload
): Promise<ApiResponse<UnitScheduleSlot[]>> =>
  api.create<ApiResponse<UnitScheduleSlot[]>>(`/units/${unitId}/schedules`, payload);
